<template>
  <v-container>
    <v-row>
      <v-col>
        <project-setting-list :min-card-height="600"> </project-setting-list>
      </v-col>
      <v-col>
        <project-setting-edit :minCardHeight="600"></project-setting-edit>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ProjectSettingEdit from '../components/project/ProjectSettingEdit.vue';
  import ProjectSettingList from '../components/project/ProjectSettingList.vue';
  export default {
    components: { ProjectSettingList, ProjectSettingEdit },
    mounted() {
      this.$store.dispatch('admin/getProjectSettingList');
    }
  };
</script>
